import { WorkloadFilterLabelValue } from '@cast/types';

import { LabelGroup } from './_types';

export const toUiModel = (filter: WorkloadFilterLabelValue[]): LabelGroup[] => {
  const valuesByLabel: Record<string, string[]> = {};
  for (const { label, value } of filter) {
    if (!label || !value) {
      // TODO: delete this 'if' when openapi spec is fixed
      continue;
    }
    const values = valuesByLabel[label] || [];
    values.push(value);
    valuesByLabel[label] = values;
  }
  return Object.entries(valuesByLabel).map(([key, value]) => ({
    key,
    value,
  }));
};

export const toBeModel = (filter: LabelGroup[]): WorkloadFilterLabelValue[] => {
  const result: WorkloadFilterLabelValue[] = [];
  for (const { key, value } of filter) {
    if (value) {
      for (const v of value) {
        if (v) {
          result.push({ label: key, value: v });
        }
      }
    }
  }
  return result;
};
